import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import merchant from './modules/merchant';
import team from './modules/team';
import invoice from './modules/invoice';
import chat from './modules/chat';
import pusher from './modules/pusher';
import contact from './modules/contact';
import contactDetails from './modules/contact_details';
import contactTag from './modules/contact_tag';
// import contactList from './modules/contact_list';
import automation from './modules/automation';
import notification from './modules/notification';
import integration from './modules/integration';
import webhook from './modules/webhook';
import inbox from './modules/inbox';
import helpers from './modules/helpers';
import organisation from './modules/organisation';
import system from './modules/system';

Vue.use(Vuex);

const initialState = {
  user: Object.assign({}, user.state),
  merchant: Object.assign({}, merchant.state),
  helpers: Object.assign({}, helpers.state),
  invoice: Object.assign({}, invoice.state),
  chat: Object.assign({}, chat.state),
  contact: Object.assign({}, contact.state),
  contactDetails: Object.assign({}, contactDetails.state),
  contactTag: Object.assign({}, contactTag.state),
  team: Object.assign({}, team.state),
  automation: Object.assign({}, automation.state),
  notification: Object.assign({}, notification.state),
  inbox: Object.assign({}, inbox.state),
  integration: Object.assign({}, integration.state),
  webhook: Object.assign({}, webhook.state),
  pusher: Object.assign({}, pusher.state),
  system: Object.assign({}, system.state),
};

const merchantStateList = [
  'team',
  'helpers',
  'invoice',
  'chat',
  'contact',
  'contactDetails',
  'contactTag',
  'automation',
  'notification',
  'inbox',
  'integration',
  'webhook',
  'system',
];

export default new Vuex.Store({
  modules: {
    user,
    merchant,
    team,
    helpers,
    invoice,
    chat,
    contact,
    contactDetails,
    contactTag,
    automation,
    notification,
    inbox,
    integration,
    webhook,
    pusher,
    organisation,
    system,
  },
  mutations: {
    // SB Note: This is a custom mutation that resets all the states in the store to their initial values
    reset(state) {
      Object.keys(state).forEach(key => Object.assign(state[key], initialState[key]));
    },
    resetMerchant(state) {
      merchantStateList.forEach(key => Object.assign(state[key], initialState[key]));
    },
    resetContactData(state) {
      Object.assign(state.contactDetails.contactData, initialState.contactDetails.contactData);
    },
  },
});
